import PropTypes from 'prop-types';

export const programType = PropTypes.object;

export const programIdType = PropTypes.number.isRequired;

export const isTravelerType = PropTypes.bool.isRequired;

export const isAdminType = PropTypes.bool.isRequired;
